import { Button, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from '../Styles/styles'

const SearchButtons = ({ id, loading, submitSearch, clearSearchResults, setShowModal, resetSearchState }) => {
  const classes = useStyles();
  return (
    <div id={id} data-testid={id} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', }}>
      {!loading
        ? <Button
          name="search"
          aria-label="submit search button"
          onClick={(e) => {
            e.preventDefault();
            submitSearch();
          }}
          className={clsx(classes.buttonHover, classes.navBarButtons)}
          data-cy="search-button"
          variant="contained"
          style={{ margin: '1em' }}
          type="submit"
        >
          Search
        </Button>
        :
        <Button
          name="search"
          aria-label="loading search button"
          className={clsx(classes.buttonHover, classes.navBarButtons)}
          data-cy="loading-button"
          disabled={true}
          variant="contained"
          style={{ margin: '1em' }}
          type="button"
        >
          <CircularProgress />
        </Button>
      }
      <Button
        name="Clear"
        aria-label="Clear button"
        onClick={() => { clearSearchResults(); resetSearchState() }}
        className={clsx(classes.buttonHover, classes.navBarButtons)}
        data-cy="Clear-button"
        variant="contained"
        style={{ margin: '1em' }}
        type="button"
      >
        Clear
      </Button>
      <Button
        name="Close"
        aria-label="Close button"
        onClick={() => { setShowModal(false); clearSearchResults(); resetSearchState() }}
        className={clsx(classes.buttonHover, classes.navBarButtons)}
        data-cy="Close-button"
        variant="contained"
        style={{ margin: '1em' }}
        type="button"
      >
        Close
      </Button>
    </div>
  );
}

export default SearchButtons;